module.exports = __webpack_public_path__ + "static/media/sanitation.0307ae48.svg";